
export const ATOMICREACH_STORE = "atomicreach/store";
export const ATOMICREACH_STORE_TYPE_GET_PROFILES = "GET_PROFILES";
export const ATOMICREACH_STORE_TYPE_SET_PROFILES = "SET_PROFILES";
export const ATOMICREACH_STORE_TYPE_TASK_LIST_FEEDBACK = "TASK_LIST_FEEDBACK";
export const ATOMICREACH_STORE_TYPE_SET_TASK_LIST_FEEDBACK = "SET_TASK_LIST_FEEDBACK";
export const ATOMICREACH_STORE_TYPE_OPTIMIZE_FEEDBACK = "OPTIMIZE_FEEDBACK";
export const ATOMICREACH_STORE_TYPE_SET_OPTIMIZE_FEEDBACK = "SET_OPTIMIZE_FEEDBACK";
export const ATOMICREACH_STORE_TYPE_OPTIMIZE_FEEDBACK_RE_HIGHLIGHTING = "OPTIMIZE_FEEDBACK_RE_HIGHLIGHTING";
export const ATOMICREACH_STORE_TYPE_SET_OPTIMIZE_FEEDBACK_RE_HIGHLIGHTING = "SET_OPTIMIZE_FEEDBACK_RE_HIGHLIGHTING";
export const ATOMICREACH_STORE_TYPE_SET_SELECTED_PROFILE = "ATOMICREACH_STORE_TYPE_SET_SELECTED_PROFILE";
export const ATOMICREACH_STORE_TYPE_SET_PARAGRAPH_STORE = "ATOMICREACH_STORE_TYPE_SET_PARAGRAPH_STORE";
export const ATOMICREACH_STORE_TYPE_SET_WORDCOUNT_STORE = "ATOMICREACH_STORE_TYPE_SET_WORDCOUNT_STORE";
export const ATOMICREACH_STORE_TYPE_SET_OPTIMIZED_PARAGRAPH_STORE = "ATOMICREACH_STORE_TYPE_SET_OPTIMIZED_PARAGRAPH_STORE";
export const ATOMICREACH_STORE_OPTIMIZE_BUTTON_STATUS = "ATOMICREACH_STORE_OPTIMIZE_BUTTON_STATUS";
export const ATOMICREACH_STORE_REVERT_BUTTON_STATUS = "ATOMICREACH_STORE_REVERT_BUTTON_STATUS";
export const ATOMICREACH_STORE_TOOLTIP_MESSAGE= "ATOMICREACH_STORE_TOOLTIP_MESSAGE";
export const ATOMICREACH_STORE_CLEAR = "ATOMICREACH_STORE_CLEAR";

export const MARK_TAG_NAME = "armarker";
export const SPELLING_GRAMMAR_CLASS = "arSpellingGrammar";
export const COMPLIANCE_CLASS = "complianceWord";
export const UPDATE_PUBLISHED = "editor-post-publish-button";
export const SAVE_DRAFT = "editor-post-save-draft";

export const TRACK_OPTIMIZE = "Optimize";
export const TRACK_OPEN_AR_TAB = "AR Tab";
export const TRACK_SAVE_DRAFT = "Save Draft";
export const TRACK_SAVE_PUBLISHED = "Save Published";
export const TRACK_APP_GUTENBERG = "Gutenberg Editor";
export const STORED_UNIQID = "aranalyzer_uniqueId";

export const OPTIMIZED_WORD_CLASS = "optimizedWord";


export const GRAMMAR_POPOVER = 'GRAMMAR_POPOVER';
export const OPTIMIZE_API_POPOVER = 'OPTIMIZE_API_POPOVER';


export const ATOMICREACH_STORE_FETCH_FROM_API = 'FETCH_FROM_API';

export const ATOMICREACH_API_NAMESPACE = "/atomicreach/v1";
export const ATOMICREACH_API_GET_PROFILES = "/get-profiles/";
export const ATOMICREACH_API_OPTIMIZE_ARTICLES = "/optimize/article/";
export const ATOMICREACH_API_ANALYZE_ARTICLES = "/titleDocumentAnalyze/article/";
export const ATOMICREACH_API_PARAGRAPH_ANALYZE_ARTICLES = "/paragraphAnalyze/article/";
export const ATOMICREACH_API_CREATE_UNIQUE_ID = '/logging/createUniqueId';
export const ATOMICREACH_API_LOG = '/logging/log';
export const ATD_TEXT_ANALYZE_URL = '/grammar/atd-info/';
export const ADD_DICTIONARY = '/dictionary/add/';
export const FLAG_WORD = '/optimize/flag/';

export const ATOMICREACH_SIDEBAR_NAME =  "atomicreach-sidebar/atomicreach-sidebar";

export const ATOMICREACH_VALID_BLOCK_NAMES_ARRAY = ["core/list","core/paragraph","core/heading","core/freeform"];

export const ATOMICREACH_PARAGRAPH_BREAK = "\n\n";
